// ============================================================================
// Configuration funnel (VSL Loom + cal.com + Thank You)
//   Réglable via variables d'env NEXT_PUBLIC_* (inlinées au build).
//   Les valeurs par défaut correspondent au funnel Bootcamp Manager Augmenté.
// ============================================================================

const env = (key: string, fallback: string) => {
  const v = process.env[key];
  return v && v.trim() ? v.trim() : fallback;
};

// --- VSL (Loom) ------------------------------------------------------------
// ID = segment après /share/ ou /embed/ dans l'URL Loom.
export const LOOM_ID = env(
  "NEXT_PUBLIC_LOOM_ID",
  "d39b8f4175604574a295390988c80da7"
);

// Vignette animée de la VSL sur /lp, servie par le site (public/media).
// C'était un GIF Loom de 1 Mo : 7,6 s d'affichage sur mobile 4G, c'était le
// plus gros élément de la page. Même animation en MP4 (144 Ko) + image fixe
// (22 Ko) affichée tout de suite. Régénérer depuis un GIF :
//   ffmpeg -i in.gif -movflags +faststart -pix_fmt yuv420p -c:v libx264 -crf 28 -an vsl-teaser.mp4
//   ffmpeg -i in.gif -vframes 1 poster.png && cwebp -q 72 poster.png -o vsl-teaser.webp
export const VSL_TEASER_VIDEO = "/media/vsl-teaser.mp4";
export const VSL_TEASER_POSTER = "/media/vsl-teaser.webp";

// --- VSL (vturb / converteai smartplayer) ----------------------------------
// Lecteur principal de la VSL (remplace Loom). IDs extraits de l'embed vturb :
//   scripts.converteai.net/{ACCOUNT_ID}/players/{PLAYER_ID}/v4/player.js
// Non secrets → fallbacks suffisants (aucun build arg requis pour les défauts ;
// n'ajouter au Dockerfile/compose que si l'on veut surcharger par env).
export const VTURB_ACCOUNT_ID = env(
  "NEXT_PUBLIC_VTURB_ACCOUNT_ID",
  "0935f08d-c2d9-4072-9fcc-b5cdf8a230ac"
);
export const VTURB_PLAYER_ID = env(
  "NEXT_PUBLIC_VTURB_PLAYER_ID",
  "6a5390f27ffebb53ceb98f08"
);

// --- cal.com ---------------------------------------------------------------
export const CAL_NAMESPACE = env(
  "NEXT_PUBLIC_CAL_NAMESPACE",
  "candidature-bootcamp-manager-ia"
);
export const CAL_LINK = env(
  "NEXT_PUBLIC_CAL_LINK",
  "akpenou/candidature-bootcamp-manager-ia"
);
// --- /meet : point expert offert (événement cal.com distinct) --------------
export const MEET_CAL_LINK = env(
  "NEXT_PUBLIC_MEET_CAL_LINK",
  "maelle-kpenou-st5upg/30min"
);
export const MEET_CAL_NAMESPACE = "meet-expert";

export const CAL_BRAND_COLOR = env("NEXT_PUBLIC_CAL_BRAND_COLOR", "#2c5f1a");

// --- Thank You -------------------------------------------------------------
export const ORGANIZER_NAME = env(
  "NEXT_PUBLIC_ORGANIZER_NAME",
  "L’équipe du Bootcamp Manager Augmenté"
);

// --- Masterclass (webinaire du jeudi 12h30) --------------------------------
// Lien de connexion au direct (Zoom / Meet / Teams / Livestorm…). Laissé vide
// par défaut : la page de confirmation dit alors que le lien arrive par email.
export const MC_JOIN_URL = env("NEXT_PUBLIC_MC_JOIN_URL", "");
